import { createApp } from 'vue';
import { Locale } from 'vant';
import { Env, Storage, I18N } from 'core';
import * as Sentry from '@sentry/vue';
import { GlobalTrack } from '@didi/global-track';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import pinia from './store';
import messages from './i18n/vant-lang';
import './style/reset.less';

// 覆盖 Vant 组建默认语言
Locale.add(messages);

// moment多语言
moment.locale('zh-cn', {
  weekdaysShort: [
    I18N.translate('Fleet_Resdesign_Sunday_jiVr', '周日'),
    I18N.translate('Fleet_Resdesign_Monday_bazB', '周一'),
    I18N.translate('Fleet_Resdesign_Tuesday_UAxw', '周二'),
    I18N.translate('Fleet_Resdesign_Wednesday_IHFc', '周三'),
    I18N.translate('Fleet_Resdesign_Thursday_JOxF', '周四'),
    I18N.translate('Fleet_Resdesign_Friday_GxZE', '周五'),
    I18N.translate('Fleet_Resdesign_Saturday_mzeO', '周六'),
  ],
});

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://e855cfb602c14351a906581ef4ddae8c@sentry-us.didiglobal.com/40',
  // 性能监控，此项会默认向请求头添加Baggage、sentry-trace字段，发部分接口无问题，但是存在接口会导致跨域问题
  // integrations: [new Integrations.BrowserTracing()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
  environment: Env.APP_ENV,
  release: `${Env.APP_NAME}@${Env.APP_VERSION}`,
  // 忽略非必要错误
  ignoreErrors: [
    'ApiError',
    'AxiosError',
    /notifyUnread is not defined/,
    /Unable to preload CSS fo/,
    /timeout of 30000ms exceeded/,
    /Failed to fetch dynamically imported module/,
  ],
});

const gTrack = new GlobalTrack();

gTrack.init({
  appKey: 'omega2851ac26f4', // appkey
  uploadHost: 'omgup.didiglobal.com', // 上报地址
  omegaKey: 'ibt_fleet_app_2_track_ck', // omegakey
  project_id: 'fleet_app', // 项目名称
  country: Storage.getCountry(), // 国家
  city: Storage.getCityid(), // 地址
});
(window as any).gTrack = gTrack;

// eslint-disable-next-line no-console
console.log('APP_COMMIT_VERSION:', Env.APP_COMMIT_VERSION);

sessionStorage.APP_COMMIT_VERSION = Env.APP_COMMIT_VERSION;

app.use(router).use(pinia).mount('#app');
